// components/ConfirmationSection.js
import { Typography } from "@mui/material";

const ConfirmationSection = ({
  handleAcceptTermsAndCondition,
  typeDemande,
}) => (
  <div className="flex flex-col justify-center items-center space-y-5 mt-8 mb-8 dark:text-white">
    <Typography className="text-center mb-8 dark:text-white" variant="h5">
      Voulez-vous vraiment soumettre votre demande ?
    </Typography>

    {(typeDemande === "avecAbon" || typeDemande === "abon") && (
      <div
        className="bg-red-100 border-l-4 border-red-500 text-red-700 p-4"
        role="status"
      >
        <p className="font-bold">Information importante</p>
        <p>
          Le montant de l'abonnement sera déduit lors de votre première
          recharge.
        </p>
      </div>
    )}

    <div className="flex items-center mb-4">
      <input
        id="terms-checkbox"
        type="checkbox"
        className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
        onChange={handleAcceptTermsAndCondition}
      />
      <label
        htmlFor="terms-checkbox"
        className="ml-2 text-sm font-medium text-gray-900"
      >
        J'accepte les{" "}
        <a
          href="/clause-juridique"
          className="text-blue-600 hover:underline"
          target="_blank"
        >
          conditions d'utilisation
        </a>{" "}
        et les{" "}
        <a
          href="/clause-juridique"
          className="text-blue-600 hover:underline"
          target="_blank"
        >
          clauses de traitement des données
        </a>
        .
      </label>
    </div>
  </div>
);

export default ConfirmationSection;
